import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=77c354c2&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c354c2')) {
      api.createRecord('77c354c2', component.options)
    } else {
      api.reload('77c354c2', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=77c354c2&", function () {
      api.rerender('77c354c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains/ibans/edit.vue"
export default component.exports